'use client';

import '@aws-amplify/ui-react/styles.css';

import { ReactNode } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import styles from './auth.module.css';

const USER_POOL_ID = process.env.NEXT_PUBLIC_USER_POOL_ID ?? '';
const USER_POOL_APP_CLIENT_ID = process.env.NEXT_PUBLIC_USER_POOL_APP_CLIENT_ID ?? '';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: USER_POOL_ID,
      userPoolClientId: USER_POOL_APP_CLIENT_ID,
    },
  },
});

export const Auth = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.container}>
      <Authenticator hideSignUp>
        <div>{children}</div>
      </Authenticator>
    </div>
  );
};
